export default "__VITE_ASSET__Cym3aDwz__"